import React from 'react';

import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

import { Button } from '@host/components/NewUI/ComponentsLibrary';

import { onboardColors } from '../../theme/onboardTokens';
import { font } from '../styles';

/** Back link at the top of the portal's item screens ("Back to portal" unless told otherwise). */
const PortalBackButton: React.FC<{ onClick: () => void; label?: string }> = ({
  onClick,
  label = 'Back to portal'
}) => (
  <Button
    buttonVariant="text"
    icon={<ArrowCircleLeftIcon sx={{ fontSize: 18 }} />}
    id="portal-back-button"
    onClick={onClick}
    sx={{
      color: onboardColors.neutral.textBody,
      fontFamily: font,
      fontSize: 16,
      fontWeight: 600,
      textTransform: 'none',
      padding: '4px 8px',
      minWidth: 0,
      borderRadius: '6px',
      '&:hover': {
        backgroundColor: onboardColors.surface.fill,
        color: onboardColors.neutral.textBody
      }
    }}
  >
    {label}
  </Button>
);

export default PortalBackButton;
